import React, { createContext, useContext, useState } from 'react';
import ContactPopup from './ContactPopup';

const ContactContext = createContext();

export const useContactPopup = () => useContext(ContactContext);

export const ContactProvider = ({ children }) => {
  const [isContactOpen, setIsContactOpen] = useState(false);

  const openContactPopup = () => setIsContactOpen(true);
  const closeContactPopup = () => setIsContactOpen(false);

  return (
    <ContactContext.Provider value={{ openContactPopup, closeContactPopup }}>
      {children}
      <ContactPopup isOpen={isContactOpen} onClose={closeContactPopup} />
    </ContactContext.Provider>
  );
};

export default ContactProvider; 